import { createStandaloneToast } from '@chakra-ui/react';
import { getMessaging, getToken, Messaging, onMessage } from 'firebase/messaging';
import { FirebaseOptions, initializeApp } from 'firebase/app';
import { MiddlewareAPI } from '@reduxjs/toolkit';
import Notification from '../../Components/Common/Notification/Notification';
import { onNotificationMessage } from '../../redux/userSlice';
import { API_BASE_URL } from '../../helpers/common';

const { toast: notify } = createStandaloneToast();
class NotificationService {
  private messaging: Messaging | null = null;
  public readonly unreadedCount: number;
  private store: MiddlewareAPI | null;

  constructor() {
    this.unreadedCount = 0;
    this.store = null;
    this.registerMessaging();
  }

  private registerMessaging() {
    const firebaseConfig: FirebaseOptions = {
      apiKey: 'AIzaSyBt1iKQk-3LaBWoKqeIWa5zwx860rGnhxQ',
      authDomain: 'balkan-d42da.firebaseapp.com',
      projectId: 'balkan-d42da',
      storageBucket: 'balkan-d42da.appspot.com',
      messagingSenderId: '874138305029',
      appId: '1:874138305029:web:985dd71e96029dfd3cd26c',
      measurementId: 'G-N3HVGC80ZE',
    };
    const app = initializeApp(firebaseConfig);
    this.messaging = getMessaging(app);
  }

  private onNotification = (message: any) => {
    this.store?.dispatch(onNotificationMessage());
    notify({
      position: 'bottom-left',
      duration: 6000,
      isClosable: true,
      render: ({ onClose }) => (
        <Notification
          title='הוֹדָעָה'
          text={message.notification.body}
          onClose={onClose}
        />
      ),
    });
  };

  private async sentToken(token: string) {
    if (!this.store) return;
    fetch(`${API_BASE_URL}/api/profile/change-token`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.store.getState().user.info.api_token}`,
      },
      body: JSON.stringify({ device_token: token }),
    });
  }

  public async connect(store: MiddlewareAPI) {
    this.store = store;
    const vapidKey = import.meta.env.VITE_FIREBASE_VAPID_KEY;
    if (!('Notification' in window) || !this.messaging || !vapidKey) {
      console.log('NOTIFICATIONS OFF');
    } else {
      console.log('NOTIFICATIONS ON');
      try {
        const permission = await window.Notification.requestPermission();
        if (permission !== 'granted') return;
        const serviceWorkerRegistration =
          await navigator.serviceWorker.ready;
        const token = await getToken(this.messaging, {
          vapidKey,
          serviceWorkerRegistration,
        });
        await this.sentToken(token);
        onMessage(this.messaging, this.onNotification);
      } catch (e: any) {
        console.log('Error in connection to firebase messaging', e.message);
      }
    }
  }
}
const notificationService = new NotificationService();
export default notificationService;
